import { createFileRoute } from '@tanstack/react-router';
import { parseLedgerSearch, type LedgerSearch } from '@/features/stock/ledger-search';
import { LedgerPage } from '@/features/stock/ledger-page';

export const Route = createFileRoute('/_app/stock/movements')({
  // the date range, every filter chip, the open movement and the form all live in
  // the URL: a filtered ledger can be pasted to the other partner, and a back from
  // an item card lands on the same page (§4.1)
  validateSearch: (s: Record<string, unknown>): LedgerSearch => parseLedgerSearch(s),
  component: function Movements() {
    return <LedgerPage search={Route.useSearch()} />;
  },
});
